import React, { useState } from 'react';
import { doc, updateDoc, arrayUnion, increment } from 'firebase/firestore';
import { db } from '../firebase';
import { getDistance } from 'geolib';

interface VerificationControlsProps {
  incidentId: string;
  incidentOwnerId: string;
  currentUserId: string;
  userLocation: { latitude: number; longitude: number } | null;
  incidentLocation: { latitude: number; longitude: number };
  verifiedBy: string[];
}

export const VerificationControls: React.FC<VerificationControlsProps> = ({
  incidentId,
  incidentOwnerId,
  currentUserId,
  userLocation,
  incidentLocation,
  verifiedBy,
}) => {
  const [isVerifying, setIsVerifying] = useState(false);

  const distance = userLocation
    ? getDistance(userLocation, incidentLocation) * 0.000621371 // Convert meters to miles
    : null;

  const canVerify = distance !== null && distance <= 0.25 && !verifiedBy.includes(currentUserId);

  const handleVerify = async () => {
    if (!canVerify) return;
    setIsVerifying(true);
    try {
      const incidentRef = doc(db, `users/${incidentOwnerId}/incidents/${incidentId}`);
      await updateDoc(incidentRef, {
        verificationCount: increment(1),
        verifiedBy: arrayUnion(currentUserId),
        confirmed: true,
      });
      // Also update user's intelScore
      const userRef = doc(db, `users/${currentUserId}`);
      await updateDoc(userRef, {
        intelScore: increment(10),
      });
    } catch (error) {
      console.error('Error verifying incident:', error);
    } finally {
      setIsVerifying(false);
    }
  };

  return (
    <div className="mt-2 font-mono">
      {distance !== null && distance > 0.25 && (
        <p className="text-xs text-red-500 mb-1">Too far to verify (&gt;{distance.toFixed(2)} miles)</p>
      )}
      <button
        onClick={handleVerify}
        disabled={!canVerify || isVerifying}
        className={`px-3 py-1 rounded-sm text-xs font-bold uppercase tracking-widest transition-colors ${
          canVerify ? 'bg-amber-600 text-black hover:bg-amber-500' : 'bg-stone-900 text-stone-600 border border-stone-800'
        }`}
      >
        {isVerifying ? 'Verifying...' : 'Verify Incident'}
      </button>
    </div>
  );
};
